var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldEnum = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.167
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M5.832 7h7M5.832 11.083h7M5.832 2.917h7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.501 9.917H1.168v2.333h2.333zM3.501 5.833H1.168v2.333h2.333zM3.501 1.75H1.168v2.333h2.333z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldEnum);
export default ForwardRef;